// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.btn-primary.dropdown-toggle:focus,
.btn-primary.icon-button:focus {
  box-shadow: none !important;
}

.custom-dropdown-menu {
  border-top: 3px solid #d3d3d3;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  padding-top: 0;
  padding-right: 10px;
  padding-left: 10px;
  width: 100%;
}

.open .dropdown-toggle {
  background-color: #000000;
}

.custom-dropdown-item {
  padding-left: 10px;
  padding-right: 10px;
}

.custom-dropdown-item:not(:last-of-type) {
  border-bottom: 1px solid #ededed;
}

.icon-button {
  border-bottom-left-radius: 18px;
  border-top-left-radius: 18px;
  border-right: 3px solid #ffffff;
  width: 40px;
  padding: 0;
}

.mat-icon-button {
  line-height: 16px;
  max-height: 33px;
}

.split-button-group .secondary-action {
  border-left: 2px solid #ffffff;
  border-radius: 0;
  padding: 0 14px;
}

.split-button-group-separate .primary-action {
  border-radius: 18px;
}
.split-button-group-separate .secondary-action {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
}
.split-button-group-separate .caret {
  color: #7a7a7a;
}
.split-button-group-separate .caret:hover {
  color: #000000;
}

.text-adjust {
  width: -moz-fit-content;
  width: fit-content;
  block-size: -moz-fit-content;
  block-size: fit-content;
}

.text-wrap {
  min-width: 215px;
}

.disabled {
  color: #caced5 !important;
  pointer-events: none;
}

.hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/@itc-core/components/split-button-dropdown/split-button-dropdown.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC3DA;;EAEC,2BAAA;AACD;;AAEA;EACC,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACD;;AAEA;EACC,yBDXO;ACYR;;AAEA;EACC,kBAAA;EACA,mBAAA;AACD;;AAEA;EACC,gCAAA;AACD;;AAEA;EACC,+BAAA;EACA,4BAAA;EACA,+BAAA;EACA,WAAA;EACA,UAAA;AACD;;AAEA;EACC,iBAAA;EACA,gBAAA;AACD;;AAGC;EACC,8BAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAKC;EACC,mBAAA;AAFF;AAKC;EACC,6BAAA;EACA,yBAAA;EACA,gBAAA;AAHF;AAMC;EACC,cDlCK;AC8BP;AAOC;EACC,cD5DM;ACuDR;;AASA;EACC,uBAAA;EAAA,kBAAA;EACA,4BAAA;EAAA,uBAAA;AAND;;AAQA;EACC,gBAAA;AALD;;AAOA;EACC,yBAAA;EACA,oBAAA;AAJD;;AAOA;EACC,aAAA;AAJD","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n.btn-primary.dropdown-toggle:focus,\n.btn-primary.icon-button:focus {\n\tbox-shadow: none !important;\n}\n\n.custom-dropdown-menu {\n\tborder-top: 3px solid $light-gray;\n\tborder-radius: 4px;\n\tmax-height: 300px;\n\toverflow-y: auto;\n\tpadding-top: 0;\n\tpadding-right: 10px;\n\tpadding-left: 10px;\n\twidth: 100%;\n}\n\n.open .dropdown-toggle {\n\tbackground-color: $black;\n}\n\n.custom-dropdown-item {\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n}\n\n.custom-dropdown-item:not(:last-of-type) {\n\tborder-bottom: 1px solid lighten($light-gray, 10);\n}\n\n.icon-button {\n\tborder-bottom-left-radius: 18px;\n\tborder-top-left-radius: 18px;\n\tborder-right: 3px solid $white;\n\twidth: 40px;\n\tpadding: 0;\n}\n\n.mat-icon-button {\n\tline-height: 16px;\n\tmax-height: 33px;\n}\n\n.split-button-group {\n\t.secondary-action {\n\t\tborder-left: 2px solid $white;\n\t\tborder-radius: 0;\n\t\tpadding: 0 14px;\n\t}\n}\n\n.split-button-group-separate {\n\t.primary-action {\n\t\tborder-radius: 18px;\n\t}\n\n\t.secondary-action {\n\t\tbackground-color: transparent;\n\t\tborder-color: transparent;\n\t\tbox-shadow: none;\n\t}\n\n\t.caret {\n\t\tcolor: $dark;\n\t}\n\n\t.caret:hover {\n\t\tcolor: $black;\n\t}\n}\n\n.text-adjust {\n\twidth: fit-content;\n\tblock-size: fit-content;\n}\n.text-wrap {\n\tmin-width: 215px;\n}\n.disabled {\n\tcolor: $disabled !important;\n\tpointer-events: none;\n}\n\n.hidden {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
